import { RudderstackBrand } from '@/_shared/components/RudderstackBrand';

/** Shown to anonymous viewers when the share token resolves to a dashboard
 * whose workspace flag is off, whose privacy was flipped back to private, or
 * was simply never valid. The same shape covers all three cases so the page
 * never reveals whether a token is real. */
export function PublicUnavailable(): React.ReactElement {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="max-w-md space-y-6 px-6 text-center">
        <RudderstackBrand variant="mark" className="mx-auto" markClassName="size-10" />
        <h1 className="text-2xl font-semibold text-foreground">This link is unavailable.</h1>
        <p className="text-sm text-muted-foreground">
          The dashboard owner may have unpublished the link or rotated it. Check with the person who shared it for an
          updated URL.
        </p>
      </div>
    </div>
  );
}
